/**
 * Pluralizes the word based on the count. Can take a custom suffix.
 */
export const pluralize = (
  noun: string,
  count?: number,
  suffix = 's'
): string => {
  if (count === 1) return noun;
  return `${noun}${suffix}`;
};
